import { createContext } from 'react';
import type { OpenApiDocumentContextValue } from '../types';

const OpenApiDocumentContext = createContext<OpenApiDocumentContextValue | null>(null);

export default OpenApiDocumentContext;
